/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemAttributeRatingTypes = 'YesNo' | 'Grade' | 'Automatic' | 'NoRating';

export const ItemAttributeRatingTypes = {
    YesNo: 'YesNo' as ItemAttributeRatingTypes,
    Grade: 'Grade' as ItemAttributeRatingTypes,
    Automatic: 'Automatic' as ItemAttributeRatingTypes,
    NoRating: 'NoRating' as ItemAttributeRatingTypes
};

